import React, { useEffect, useState } from 'react'
import {Link} from "react-router-dom";
import "../../styles/matchStatsYellowCard.css";

export default function MatchStatsYellowCard({ stats }) {
    const [isOpen, setIsOpen] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(null);

    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    setIsLoggedIn(false);
                }
                else if (data.loggedIn) {
                    setIsLoggedIn(true);
                }
            });
    }, []);

    return (
        <div className='yellow-stats-card'>

            <div className='yellow-stat-title' onClick={() => setIsOpen(!isOpen)}>
                Sárga lap esetén kihagyják a következő mérkőzést
            </div>



            {isOpen && (

                isLoggedIn ?
                    (
                        <>
                            <div className='yellow-stat-header'>
                                {/* <img src={`/images/teams/${stats.teams.home.logo}`} alt={stats.teams.home.name} />
                    <img src={`/images/teams/${stats.teams.away.logo}`} alt={stats.teams.away.name} /> */}
                                <img src="https://focifanatik.hu/images/teams/psg.png" alt="" />
                                <img src="https://focifanatik.hu/images/teams/brentford.png" alt="" />
                            </div>

                            <div className='yellow-stat-list'>
                                {stats.injured.map(yel => {
                                    return (
                                        <div className='yellow-stat-row'>

                                            <span className='yellow-stat-value'>
                                                {yel.home_value}
                                            </span>

                                            <span className='yellow-stat-value'>
                                                {yel.away_value}
                                            </span>

                                        </div>
                                    )
                                })}

                            </div>
                        </>
                    )
                    :
                    (
                        <div className="stats-locked-card">

                            <div className="lock-icon">
                                🔒
                            </div>

                            <h3>Részletes statisztikák</h3>

                            <p>
                                Jelentkezz be vagy regisztrálj a teljes statisztikák
                                megtekintéséhez.
                            </p>

                            <div className="stats-lock-buttons">
                                <Link to="/bejelentkezes"><button className="login-btn">Bejelentkezés</button></Link>
                                <Link to="/regisztracio"><button className="register-btn">Regisztráció</button></Link>

                            </div>

                        </div>
                    )


            )}

        </div>
    )
}
